import createAPI from '../axios'

const skillsTraining = {
    //培训岗位
    trainingPositions: {
        save: config => createAPI('/skillsTraining/trainingPositions/save', 'post', config),
        initCombo: config => createAPI('/skillsTraining/trainingPositions/initCombo', 'post', config),
        queryList: config => createAPI('/skillsTraining/trainingPositions/queryList', 'post', config),
        del: config => createAPI('/skillsTraining/trainingPositions/del', 'post', config),
        releaseRecById: config => createAPI('/skillsTraining/trainingPositions/releaseRecById', 'post', config),
    },
    //培训课程
    trainingCourse: {
        initOption: config => createAPI('/skillsTraining/trainingCourse/initOption', 'post', config),
        save: config => createAPI('/skillsTraining/trainingCourse/save', 'post', config),
        queryList: config => createAPI('/skillsTraining/trainingCourse/queryList', 'post', config),
        del: config => createAPI('/skillsTraining/trainingCourse/del', 'post', config),
        releaseRecById: config => createAPI('/skillsTraining/trainingCourse/releaseRecById', 'post', config),
        trainingCourseDocumentUpload: config => createAPI('/skillsTraining/trainingCourse/trainingCourseDocumentUpload', 'post', config),
        deleteDocumentFile: config => createAPI('/skillsTraining/trainingCourse/deleteDocumentFile', 'get', config),
        queryDocumentByCourseId: config => createAPI('/skillsTraining/trainingCourse/queryDocumentByCourseId', 'get', config),
    },
    //学生管理
    stuManagement: {
        queryList: config => createAPI('/skillsTraining/stuManagement/queryList', 'post', config),
        drxymc: config => createAPI('/skillsTraining/stuManagement/drxymc', 'post', config),
        batchExport: config => createAPI('/skillsTraining/stuManagement/batchExport', 'post', config),
        initCombo: config => createAPI('/skillsTraining/stuManagement/initCombo', 'post', config),
        save: config => createAPI('/skillsTraining/stuManagement/save', 'post', config),
    },

}
export default skillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/skillsTraining.js